import { RouteState } from "../api/edits/editRoute.responses";
import useEditRouteService from "../api/edits/editRoute.service";
import { useUploadService } from "../api/edits/upload.service";
import { preparePOIDataForDB, prepareRouteDataForDB } from "../utils/helpers";

export function useSaveRouteData() {
  const {
    updateRouteAndTranslations,
    updateGeoLine,
    updateAmbientSounds,
    updatePOIs,
  } = useEditRouteService();
  const { commitUpload } = useUploadService();

  const saveRouteData = async (routeState: RouteState): Promise<void> => {
    const routePayload = prepareRouteDataForDB(routeState);
    const poiPayload = preparePOIDataForDB(routeState.pointsOfInterest);
    const ambientSounds = {
      backgroundSounds: routeState.backgroundSounds.map(({ id, ...rest }) => rest),
      focusedSounds: routeState.focusedSounds.map(({ id, falloffName, ...rest }) => rest),
    };

    await updateRouteAndTranslations(routeState.id, routePayload);
    await updateGeoLine(routeState.id, routeState.linePoints);
    await updateAmbientSounds(routeState.id, ambientSounds);
    await updatePOIs(routeState.id, poiPayload);

    if (routeState.pendingUploadCommits?.length) {
      for (const commit of routeState.pendingUploadCommits) {
        await commitUpload(routeState.id, commit);
      }
    }
  };

  return { saveRouteData };
}
